export default __webpack_public_path__ + "static/media/total-shape-Drq07X98BqM-unsplash.593fa7d2.jpg";